import { merge } from 'lodash';

const defaultAttrs = {
  convertor: true,
  flake: true,
  id: true,
  leavingTerm: true,
  rate: true,
  totalStakedFlake: true
};

export default (attrs = {}) => ({
  baseFlakeInfos: {
    ...merge({}, defaultAttrs, attrs)
  }
});
